// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2BjpV","content":"styles_content__2I-aY","contentHeader":"styles_contentHeader__3whWQ","withAction":"styles_withAction__10A0L"};